var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 오늘의 점검 헤드 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reloadSpg, userInfoLoginState } from "../../../recoil/userState";
// utils
import { alertState, checkTypeState, curSchduleTreeState, mainState } from "../../../recoil/assessmentState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
import DaysMain from "./days/DaysMain";
import InspectionList from "./inspection/InspectionList";
function dailysInspectionView(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const [reload, setReload] = useRecoilState(reloadSpg);
    const check = useRecoilValue(checkTypeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilState = useSetRecoilState(mainState);
    // props
    const { curTree, handleOpenPop } = props;
    // useState
    const [companyItem, setCompanyItem] = useState([]);
    const [subZoneInfo, setSubZoneInfo] = useState([]);
    const [roomInfo, setRoomInfo] = useState([]);
    const [zone, setZone] = useState(null);
    const [selTab, setSelTab] = useState(check.checkType);
    const [dates, setDates] = useState(false);
    // timeOut
    useEffect(() => {
        let timer = setTimeout(() => {
            setDates(false);
        }, 900);
        if (dates === false) {
            setReload(true);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [dates]);
    function ZoneSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/zone/filter`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCompanyItem(data.body);
                    CUTIL.selectFoucs("s" + curTree.zone.zoneId, { num: 0 });
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function ZoneClick(item) {
        const zoenName = item.name.replace(item.companyId, "").trim();
        setRecoilTreeData({
            company: { companyId: item.companyId, companyName: item.companyId },
            zone: { zoneId: item.zoneId, zoneName: zoenName, zoneBoolean: true },
            subZone: { subZoneId: "", subZoneName: "", subZoneBoolean: false },
            room: { roomId: "", roomName: "", roomBoolean: false },
            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
        });
        setZone(item.name);
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zoneId,
        });
        const atag = document.getElementById(item.zoneId);
        // const offset = atag.offsetTop;
        atag.scrollIntoView({
            block: "center",
        });
        window.scrollTo({ top: 0 });
    }
    // SubZone
    function SubZoneSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/zone/${curTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubZoneInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickSubZone(item) {
        if (item == "all") {
            setRecoilTreeData({
                company: { companyId: curTree.company.companyId, companyName: curTree.company.companyName },
                zone: { zoneId: curTree.zone.zoneId, zoneName: curTree.zone.zoneName, zoneBoolean: true },
                subZone: { subZoneId: "", subZoneName: "", subZoneBoolean: false },
                room: { roomId: "", roomName: "", roomBoolean: false },
                spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
            });
        }
        else {
            setRecoilTreeData({
                company: { companyId: curTree.company.companyId, companyName: curTree.company.companyName },
                zone: { zoneId: curTree.zone.zoneId, zoneName: curTree.zone.zoneName, zoneBoolean: false },
                subZone: { subZoneId: item.subZoneId, subZoneName: item.subZoneName, subZoneBoolean: true },
                room: { roomId: "", roomName: "", roomBoolean: false },
                spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
            });
            const atag = document.getElementById(item.subZoneId);
            // const offset = atag.offsetTop;
            atag.scrollIntoView({
                block: "center",
            });
            window.scrollTo({ top: 0 });
        }
    }
    // SubZone
    function RoomSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/subzone/${curTree.subZone.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRoomInfo(data.body);
                    CUTIL.selectFoucs(`room${curTree.room.roomId == "" ? "All" : curTree.room.roomId}`, { num: 0 });
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function subTab(e, selTab) {
        e.preventDefault();
        setSelTab(selTab);
    }
    function onClickRoom(item) {
        if (item == "all") {
            setRecoilTreeData({
                company: { companyId: curTree.company.companyId, companyName: curTree.company.companyName },
                zone: { zoneId: curTree.zone.zoneId, zoneName: curTree.zone.zoneName, zoneBoolean: false },
                subZone: {
                    subZoneId: curTree.subZone.subZoneId,
                    subZoneName: curTree.subZone.subZoneName,
                    subZoneBoolean: true,
                },
                room: { roomId: "", roomName: "", roomBoolean: false },
                spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
            });
        }
        else {
            setRecoilTreeData({
                company: { companyId: curTree.company.companyId, companyName: curTree.company.companyName },
                zone: { zoneId: curTree.zone.zoneId, zoneName: curTree.zone.zoneName, zoneBoolean: false },
                subZone: {
                    subZoneId: curTree.subZone.subZoneId,
                    subZoneName: curTree.subZone.subZoneName,
                    subZoneBoolean: false,
                },
                room: { roomId: item.roomId, roomName: item.roomName, roomBoolean: true },
                spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
            });
            const atag = document.getElementById(item.roomId);
            // const offset = atag.offsetTop;
            atag.scrollIntoView({
                block: "center",
            });
            window.scrollTo({ top: 0 });
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("article", Object.assign({ className: `box ` }, { children: [_jsxs("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: [_jsxs("div", Object.assign({ className: "flex-inline gap-24 m-none" }, { children: [_jsxs("div", Object.assign({ className: "select zone", onClick: (e) => ZoneSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: curTree.company.companyName + " " + curTree.zone.zoneName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: `option ${item.zoneId == curTree.zone.zoneId ? "active" : ""}`, id: "s" + item.zoneId, onClick: (e) => ZoneClick(item), title: item.name }, { children: item.name }), "zone_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "select subzone", onClick: (e) => SubZoneSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": curTree.subZone.subZoneId }, { children: curTree.subZone.subZoneId ? curTree.subZone.subZoneName : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: `option ${curTree.subZone.subZoneId == "" ? "active" : ""}`, onClick: (e) => onClickSubZone("all"), title: t("라벨.전체") }, { children: t("라벨.전체") })), subZoneInfo.length > 0 &&
                                                    subZoneInfo.map((info, idx) => (_jsx("li", Object.assign({ className: `option ${curTree.subZone.subZoneId == info.subZoneId ? "active" : ""}`, id: "subAll", onClick: (e) => onClickSubZone(info), title: info.subZoneName }, { children: info.subZoneName }), "subZone_" + idx.toString())))] })] })), _jsxs("div", Object.assign({ className: "select room", onClick: (e) => {
                                        curTree.subZone.subZoneId && RoomSelect(e);
                                    } }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": curTree.room.roomId ? curTree.room.roomName : "" }, { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: `option ${curTree.room.roomId == "" ? "active" : ""}`, id: "roomAll", onClick: (e) => onClickRoom("all"), title: t("라벨.전체") }, { children: t("라벨.전체") })), roomInfo &&
                                                    roomInfo.map((info, idx) => (_jsx("li", Object.assign({ className: `option ${curTree.room.roomId == info.roomId ? "active" : ""}`, id: "room" + info.roomId, onClick: (e) => onClickRoom(info), title: info.roomName }, { children: info.roomName }), "room_" + idx.toString())))] })] }))] })), _jsxs("ul", Object.assign({ className: "tab__line mt-26 pl-12 pr-36" }, { children: [_jsx("li", Object.assign({ className: `${selTab == "daily" ? "on" : ""}`, onClick: (e) => subTab(e, "daily") }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("라벨.일정별") })) })), _jsx("li", Object.assign({ className: `${selTab == "inspetion" ? "on" : ""}`, onClick: (e) => subTab(e, "inspetion") }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("라벨.설비별") })) }))] }))] })), curTree.zone.zoneId && selTab === "daily" && _jsx(DaysMain, { curTree: curTree, handleOpenPop: handleOpenPop }), curTree.zone.zoneId && selTab === "inspetion" && (_jsx(InspectionList, { curTree: curTree, handleOpenPop: handleOpenPop }))] })) }));
}
export default dailysInspectionView;
